const b = () => {
  let d;
  return async (c, t) => {
    var i;
    if (typeof window > "u")
      return;
    if (d)
      return d;
    if ((i = t == null ? void 0 : t.signal) != null && i.aborted)
      throw new DOMException("Aborted", "AbortError");
    const s = (e) => new Promise((w, a) => {
      const n = () => {
        a(new DOMException("Aborted", "AbortError"));
      };
      e == null || e.addEventListener("abort", n);
      const r = document.createElement("script");
      r.async = !0, r.src = c, r.addEventListener("load", () => {
        e == null || e.removeEventListener("abort", n);
        const o = window;
        d = o.Communicator, w(o.Communicator);
      }), r.addEventListener("error", (o) => {
        e == null || e.removeEventListener("abort", n), a(o);
      }), document.body.appendChild(r);
    });
    try {
      return await s(t == null ? void 0 : t.signal);
    } catch (e) {
      throw e instanceof Error && console.error(`Cannot load hoops script: ${e.message}`), e;
    }
  };
};
export {
  b as getHoopsLibraryLoader
};
//# sourceMappingURL=HoopsViewerLoader.utils.mjs.map
